import { getAuthPath } from '@edu-frontend/modules/src/shared/lib/passportUrls';

export function redirectToAuth(backpath: string, retpath: string) {
    window.location.href = getAuthPath({
        backpath,
        retpath,
    });
}
